import { pluralize } from './strings';

/**
 * Counts, the platform way: written as words, and never zero.
 *
 *   formatCount(21, 'card')   -> '21 cards'
 *   formatCount(1, 'item')    -> '1 item'
 *   formatCount(0, 'card')    -> null   (zero is not information)
 *
 * A surface that has something to say at zero says it in words of its own
 * ("Empty · Add a card"), never as "0 cards" or an icon beside a number.
 */
export const formatCount = (count, singular, plural) => {
	const n = Number(count);
	if (!Number.isFinite(n) || n <= 0) return null;
	const noun = n === 1 ? singular : (plural || pluralize(singular));
	return `${n} ${noun}`;
};

/**
 * One meta line from several optional facts: blanks drop out, the rest join
 * with the platform's middle dot.
 *
 *   joinMeta('21 cards', null, '94 items') -> '21 cards · 94 items'
 */
export const joinMeta = (...parts) => parts
	.flat()
	.filter(part => part !== null && part !== undefined && part !== '' && part !== false)
	.join(' · ');
